// extracted by mini-css-extract-plugin
module.exports = {"panel":"LayoutGame_panel__26eg7","container":"LayoutGame_container__2uqZ_"};